window.Page = {

    buyButtons : document.querySelectorAll('.js-shopify-button'),

    // Let's launch this thing
    liftoff : () => {

        window.addEventListener("load", () => {
            if (window.ShopifyBuy && window.ShopifyBuy.UI) {
                Page.initShopify()
            }
        })


    },

    // My new function block
    initShopify : () => {
        
        // Client Settings
        var client = window.ShopifyBuy.buildClient({
            domain                : '0b0jae-yq.myshopify.com',
            storefrontAccessToken : '932288c32815339b3f8d0d2c14a833ba',
        });
        
        //button: buttonTemplate,

        // Create the button itself
        window.ShopifyBuy.UI.onReady(client).then(function (ui) {

            Page.buyButtons.forEach(buyButton => {
                ui.createComponent('product', {
                    id          : buyButton.dataset.id,
                    node        : document.getElementById(`product-component-${buyButton.dataset.id}`),
                    moneyFormat : '%24%7B%7Bamount%7D%7D',
                    options     : {
                        "product": {
                            "iframe"            : false,
                            "buttonDestination" : "checkout",
                            "contents" : {
                                "img"   : false,
                                "title" : false,
                                "price" : false,
                            },
                            "text": {
                                "button"      : 'Buy now',
                                "outOfStock"  : 'Sold out [restock soon]',
                                "unavailable" : 'Unavailable',
                            },
                            "templates" : {
                                "button": '<div class="{{data.classes.product.buttonWrapper}}" data-element="product.buttonWrapper"><button {{#data.buttonDisabled}}disabled{{/data.buttonDisabled}} class="{{data.classes.product.button}} {{data.buttonClass}}" data-element="product.button">[{{data.formattedPrice}}] {{data.buttonText}}</button></div>',
                            }
                            
                        },
                    }
                })
            })

        })

    }

};

Page.liftoff()